import _ from "lodash";
import React, { useState } from "react";
import classes from "./ReportSubmissionViewer.scss";

import UIModal from "UIComponents/UIModal";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { useI18n } from "Hooks";

import PageHeaderComponent from "Projects/routes/DeadlinesV2/routes/ProjectDeadline/components/PageHeader";
import SubmissionViewer from "Projects/components/SubmissionViewer";
import { submissionTypeTitle } from "../../modules/Utils";

const ReportSubmissionViewer = ({
  projectTask,
  selectedAttachmentId,
  projectGroupType,
  studentDetails,
  onCloseModal,

  onDeleteAttachment,
  onUpdateAttachment,
  onCreateAttachment,
  onUpdateInputField,
  onUpdateProjectDeadlineSubmission,
  onUpdateProjectDeadline,
  projectDisabled,
  isAnnotationEnabled,
  projectGroupSubType,
  autoCheckSimilarityRef,
  projectId,
}) => {
  const { task: projectGroupTask, latestSubmissionResponse } = projectTask;
  const [isRightContainerVisible, setIsRightContainerVisible] = useState(true);

  const toggleRightContainerVisibility = () => {
    setIsRightContainerVisible(prevState => !prevState);
  };

  const { t } = useI18n(["common", "project"]);

  const projectStudentDetails = {
    studentDetails: _.map(studentDetails, student => {
      return {
        ...student,
        name: getFormattedUserName({ user: student, type: "student" }),
      };
    }),
  };

  const {
    submission: { title: submissionTitle },
  } = projectGroupTask;

  const { itemResponses } = latestSubmissionResponse;

  const attachments = _.flatten(
    _.map(itemResponses, itemResponse => {
      if (itemResponse?.attachments) return itemResponse.attachments;
    })
  );

  const handleAttachmentUpdate = ({ attachmentId, newName }) => {
    const attachmentToUpdate = _.cloneDeep(
      _.find(attachments, { id: attachmentId })
    );
    attachmentToUpdate["name"] = newName;
    onUpdateAttachment({
      attachmentToUpdate,
    });
  };

  return (
    <UIModal isOpen={true} isFullScreen={true}>
      <div className={classes.container}>
        <PageHeaderComponent
          deadlineDetails={projectGroupTask}
          projectGroupType={projectGroupType}
          projectDetailsWithTask={projectTask}
          onGoToBack={onCloseModal}
          onUpdateProjectDeadline={onUpdateProjectDeadline}
          onUpdateProjectDeadlineSubmission={onUpdateProjectDeadlineSubmission}
          headerTitle={t(submissionTypeTitle[submissionTitle])}
          projectGroupSubType={projectGroupSubType}
        />
        <SubmissionViewer
          projectStudentDetails={projectStudentDetails}
          projectDetailsWithTask={projectTask}
          // showEmptyState={showEmptyState}
          //   key={projectId}
          onDeleteAttachment={onDeleteAttachment}
          onCreateAttachment={onCreateAttachment}
          onUpdateAttachment={handleAttachmentUpdate}
          onUpdateInputField={onUpdateInputField}
          disabled={projectDisabled}
          presetSelectedAttachment={{
            id: selectedAttachmentId,
            isAnnotationEnabled,
          }}
          autoCheckSimilarityRef={autoCheckSimilarityRef}
          projectId={projectId}
          projectGroupSubType={projectGroupSubType}
          toggleRightContainerVisibility={toggleRightContainerVisibility}
          isRightContainerVisible={isRightContainerVisible}
        />
      </div>
    </UIModal>
  );
};

export default ReportSubmissionViewer;
